import { PubListConfigListTypeEnum } from "api/publist/models";
import { SidebarTab } from "./types";

type SidebarTabMap = { [key in SidebarTab] };
type ListTypeMap = { [key in PubListConfigListTypeEnum] };

export const SidebarTabListTypeMap: SidebarTabMap = {
  [SidebarTab.PUBLIST]: PubListConfigListTypeEnum.PUBLICATION,
  [SidebarTab.RESEARCH_DATA_LIST]: PubListConfigListTypeEnum.RESEARCHDATA,
};

export const ListTypeSidebarTabMap: ListTypeMap = {
  [PubListConfigListTypeEnum.PUBLICATION]: SidebarTab.PUBLIST,
  [PubListConfigListTypeEnum.RESEARCHDATA]: SidebarTab.RESEARCH_DATA_LIST,
  [PubListConfigListTypeEnum.ALL]: '',
};